import type { ReactNode } from "react";
import { cn } from "../../lib/cn";
import { StatusRing } from "../data/status-ring";

/** Calm "nothing to do" state (D0 principle): the default when nothing needs the user. */
export function CalmState({ title = "All products monitored. No action needed.", children, action, compact }: { title?: string; children?: ReactNode; action?: ReactNode; compact?: boolean }) {
  return (
    <section aria-label={title} className={cn("card flex flex-col gap-4 sm:flex-row sm:items-center", compact ? "p-4" : "rounded-modal p-6 shadow-raised")}>
      <StatusRing severity="ok" size={compact ? 36 : 64} />
      <div className="min-w-0 flex-1 space-y-1">
        <p className={cn("heading", compact ? "text-base" : "text-xl")}>{title}</p>
        {children && <div className="text-sm text-text-muted">{children}</div>}
      </div>
      {action}
    </section>
  );
}
